module.exports = __webpack_public_path__ + "static/media/jagoan_coding_logo.2d325010.png";